<style scoped>
    .city-selector{
        display: inline-block;
    }
    .hot-city{
        margin-right: 5px;
        margin-bottom: 5px;
    }
</style>
<template>
    <div class="city-selector">
        <Poptip trigger="focus" title="热门城市" :placement="placement">
            <Input :size="size" autocomplete="new-password" :placeholder="placeholder" :value="value" :disabled="disabled" @on-change="inputChange" icon="ios-pin" />
            <div slot="content">
                <Button size="small"
                        class="hot-city"
                        @click="setCity(city)"
                        v-for="(city, i) in hot_cities"
                        :key="i">
                    {{city.name}}
                </Button>
                <div class="color-grey">其他城市请在输入框直接输入</div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    import Util from '../../../libs/util';
    export default {
        props: {
            value: {
                type: String
            },
            size: {
                type: String,
                'default': ''
            },
            placeholder: {
                type: String,
                'default': ''
            },
            placement: {
                type: String,
                'default': 'bottom'
            },
            disabled: {
                type: Boolean,
                'default': false
            }
        },
        data(){
            return {
                hot_cities: [
                    {
                        name: "成都",
                        data: "Chengdu|成都(CTU)|28|CTU"
                    },
                    {
                        name: "北京",
                        data: "Beijing|北京(BJS)|1|BJS"
                    },
                    {
                        name: "上海",
                        data: "Shanghai|上海(SHA)|2|SHA"
                    },
                    {
                        name: "广州",
                        data: "Guangzhou|广州(CAN)|32|CAN"
                    },
                    {
                        name: "深圳",
                        data: "Shenzhen|深圳(SZX)|30|SZX"
                    }
                ]
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            setCity(city){
                this.$emit('input', city.name);
            },
            inputChange(event){
                this.$emit('input', event.target.value);
            }
        }
    }
</script>
